var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaCei(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 18.04 8.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff9300;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.54,2.07c.36-.65,.86-1.16,1.51-1.52,.64-.36,1.37-.55,2.19-.55,1,0,1.86,.26,2.57,.79,.71,.53,1.19,1.25,1.43,2.16h-2.26c-.17-.35-.41-.62-.71-.8-.31-.18-.66-.28-1.05-.28-.63,0-1.14,.22-1.54,.66-.39,.44-.59,1.03-.59,1.76s.2,1.32,.59,1.76c.39,.44,.9,.66,1.54,.66,.39,0,.74-.09,1.05-.28,.31-.18,.55-.45,.71-.8h2.26c-.24,.91-.72,1.63-1.43,2.15-.71,.52-1.57,.79-2.57,.79-.82,0-1.55-.18-2.19-.55-.64-.36-1.15-.87-1.51-1.52-.36-.65-.54-1.39-.54-2.22s.18-1.57,.54-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.54,1.74v1.7h2.75v1.58h-2.75v1.85h3.11v1.64h-5.16V.1h5.16V1.74h-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.04,.1V8.52h-2.05V.1h2.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaCei);
export default __webpack_public_path__ + "static/media/da_cei.62fe5506a34e7b7a7045f8279288b51e.svg";
export { ForwardRef as ReactComponent };